// The prop predicates both platform packages need.
//
// These were `-mobile`'s, in bidCardShapes.js beside the closed shapes that use
// them, and they moved here the moment a `-shared` component wanted one:
// AvatarChip's `imageUrl` takes exactly the shape BidCard's and BidSheet's do,
// and `-shared` cannot import from `-mobile` because the dependency runs the
// other way. The alternative was a third copy of a one-line predicate, which is
// how a rule becomes an accident — see *No Duplicated Functionality* in
// knowledge-base/standards/design-principles.md.
//
// bidCardShapes.js re-exports both, so nothing that imports them today moves.
// That is the same arrangement utils/formatters.js already uses for the avatar
// gradient, one directory over.

/** A string with something in it: a blank is not a value a slot can draw. */
export const isNonBlankString = (value) => typeof value === 'string' && value.trim() !== '';

/** `null` for absent, or a non-blank string. The shape every optional text prop takes. */
export const isAbsentOrNonBlankString = (value) => value === null || isNonBlankString(value);
